<template>
    <div class="pl-0 pr-0">
        <c-column-header
            :label = "title"
            class="primary white--text"
            :title-border = "true"
        >
            <template v-slot:pre>
                <slot name="menu"></slot>
            </template>
        </c-column-header>

        <div v-if="!hasData" class="no-data lm-border ">
            <v-row dense >
                <v-col>
                    Keine Daten
                </v-col>
            </v-row>
        </div>

        <div v-if="hasData" class="table-frame pb-2" :class="showBorder ? 'lm-border ' : ''" style="border-top-style: none; border-top-left-radius: 0!important;border-top-right-radius: 0!important;">
            <v-row v-if="hasData && showHeader" dense class="primary--text data-title pt-2" style="margin-top: 2px; border-top-left-radius: 4px; border-top-right-radius: 4px; font-size: 14px; ">
                <slot name="header"></slot>
            </v-row>

            <div
                v-if   = "showBody"
                class  = "table-scroll"
                :style = "'max-height:' + (height - (showHeader ? 450 : 415)) + 'px;'"
            >
                <slot name="body"></slot>
            </div>

            <slot name ="content"></slot>
        </div>
    </div>
</template>

<script>
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";

export default {
    name: "CInspectionData",
    components: {
        CColumnHeader
    },

    props: {
        title: {

        },

        hasData: {

        },

        showHeader: {
            required: false,
            default : function () {
                return true;
            },
        },

        showBody: {
            required: false,
            default : function () {
                return true;
            },
        },

        showBorder: {
            required: false,
            default : function () {
                return true;
            },
        },

        height: {

        }
    },

    methods: {
        onTransfer () {
            this.$emit("transfer");
        }
    }
}
</script>

<style scoped>

.no-data {
    width: 100%;
    height: 100%;
    min-height: 595px;
    font-size: 30px;
    color: lightgray;
    text-align: center;
    padding-top: 25%;
}

.data-title {
    font-size: 15px;
    font-weight: 600;
    border-bottom-style: solid;
    border-bottom-width: 1px;
}

</style>